import React, { useState } from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FaChartLine } from 'react-icons/fa'
import { FiChevronDown, FiChevronRight } from 'react-icons/fi'
import {
  Label,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import {
  getUserId,
  getUserPriceGroup,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import {
  isInPlanScope,
  isInPlanScopeRedirect,
  PlansScope,
  useLicensePlansScope,
} from '../index'
import Flex from 'typescript-styled-flex'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'
import { useMediaQuery, useTheme } from '@material-ui/core'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function Finance({
  isSidebarOpen,
  size = 1,
  className,
}: IFinanceProps & WithTranslation & IWithSize) {
  const [isOpen, toggleOpen] = React.useState(false)
  const planScope = useLicensePlansScope()
  const userId = useSelector(getUserId)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [isModalOpened, setIsModalOpened] = useState(false)

  const handleLinkClick = (event, userPlanScope) => {
    if (
      userPlanScope &&
      isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (
      userPlanScope &&
      !isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      handlePopoverOpen(event)
    }
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //   setPopoverAnchor(target)
  // }

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  function toggleIsOpen() {
    toggleOpen(!isOpen)
  }

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Financial Report Menu Opened', 1)
    Mixpanel.track('Main Menu Financial Report Item Used', {})
  }

  const trackClick2 = () => {
    Mixpanel.people.increment(userId, 'Room Report Menu Opened', 1)
    Mixpanel.track('Main Menu Room Report Item Used', {})
  }

  const trackClick3 = () => {
    Mixpanel.people.increment(userId, 'Statistics Menu Opened', 1)
    Mixpanel.track('Statistics Menu Item Used', {})
  }

  const trackClick4 = () => {
    Mixpanel.people.increment(userId, 'Export Menu Opened', 1)
    Mixpanel.track('Main Menu Export Item Used', {})
  }

  const trackClick5 = () => {
    Mixpanel.people.increment(userId, 'Registration Book Menu Opened', 1)
    Mixpanel.track('Main Menu Registration Book Item Used', {})
  }

  const trackClick6 = () => {
    Mixpanel.people.increment(userId, 'Payment List Menu Opened', 1)
    Mixpanel.track('Main Menu Payment List Item Used', {})
  }

  const scopes = useIsScope({
    export: [PermissionScope.SCOPE_CAN_USE_EXPORT],
    reports: [PermissionScope.SCOPE_CAN_USE_FINANCIAL_REPORTS],
    booking: [PermissionScope.SCOPE_CAN_USE_OCCUPANCY_REPORTS],
  })

  const trackClick7 = () => {
    Mixpanel.people.increment(userId, 'New Statistics Menu Opened', 1)
    Mixpanel.track('New Statistics Menu Item Used', {})
  }

  const trackClick8 = () => {
    Mixpanel.track('Local Tax Report Menu Item Used', [])
    Mixpanel.people.increment(userId, 'Local Tax Report Menu Opened', 1)
  }

  return (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          className={`${className}-button-expand`}
          nested={true}
        >
          <b>
            <FaChartLine size={16 * size} />
          </b>
          <Label size={size} primary={true} className={`${className}-label`}>
            <Trans i18nKey={'BED_5074_reports_and_finances'}>
              Raporty i finanse
            </Trans>
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
        {isSidebarOpen && (
          <MenuList nested={true} size={size}>
            {scopes.reports && (
              <SmartLink
                onClick={e => {
                  handleLinkClick(e, PlansScope.Statistics)
                  trackClick7()
                }}
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.Statistics,
                  '/statistics/overview',
                  userPriceGroup,
                )}
                activeClassName={'active'}
                nested={true}
                className={`${className}-item-1-label`}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.Statistics,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter={true}
                  className={`${className}-item-1-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey={'menu_statistics'}>Statystyki</Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.Statistics,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {scopes.reports && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.FinancialReport,
                  '/finance/report',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-1-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.FinancialReport)
                  trackClick()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.FinancialReport,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-1-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="menu_finances_report">
                      Raport finansowy
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.FinancialReport,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {scopes.reports && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.RoomReport,
                  '/statistics/room',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-1-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.RoomReport)
                  trackClick2()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.RoomReport,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-1-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="z4806_label">Raport pokoi</Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.RoomReport,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {scopes.booking && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.OccupancyReport,
                  '/statistics/reservations',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-2-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.OccupancyReport)
                  trackClick3()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.OccupancyReport,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-2-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="BED_3604_occupancy_report">
                      Raport obłożenia
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.OccupancyReport,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}

            {scopes.reports && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.LocalTaxReport,
                  '/statistics/local-tax-report',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-2-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.LocalTaxReport)
                  trackClick8()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.LocalTaxReport,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-2-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="BED_6317_local_tax_report">
                      Raport podatku lokalnego
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.LocalTaxReport,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}

            {scopes.reports && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.PaymentList,
                  '/statistics/payments',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-2-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.PaymentList)
                  trackClick6()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.PaymentList,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-2-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="menu_finances_payment_list">
                      Lista płatności
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.PaymentList,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {scopes.reports && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.LodgingBook,
                  '/statistics/book',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-2-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.LodgingBook)
                  trackClick5()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.LodgingBook,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-2-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="BKO_1130_registration_book">
                      Księga meldunkowa
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.LodgingBook,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {scopes.export && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.ReservationExport,
                  '/booking/export',
                  userPriceGroup,
                )}
                activeClassName="active"
                nested
                className={`${className}-item-5-label`}
                onClick={e => {
                  handleLinkClick(e, PlansScope.ReservationExport)
                  trackClick4()
                }}
              >
                <MenuElement
                  // onMouseEnter={
                  //   !isMobile &&
                  //   isInPlanScope(
                  //     planScope,
                  //     PlansScope.ReservationExport,
                  //     userPriceGroup,
                  //   )
                  //     ? handleMouseEnter
                  //     : undefined
                  // }
                  size={size}
                  alignCenter
                  className={`${className}-item-5-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey="title_activity_export">
                      Eksport rezerwacji
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.ReservationExport,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
          </MenuList>
        )}
      </MenuElement>
      <Flex
        style={{ marginLeft: 'auto' }}
        alignCenter
        justifyEnd
      >
        <PopoveredIcon2
          withIcon={false}
          anchorEl={popoverAnchor}
          onOpen={handlePopoverOpen}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
        />
      </Flex>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default Finance

export interface IFinanceProps {
  isSidebarOpen: boolean
  className?: string
}
